import { TagCategoryTagDto } from "generated/graphql";
import { defaultSerializer, SerializerOptions } from "../index";

export const TagCategoryTagDtoSerializer = {
  type: "TagCategoryTagDto",
  serializer: (entity: TagCategoryTagDto, options: SerializerOptions): Partial<TagCategoryTagDto> | null => {
    if (options?.parent?.__typename === "TagCategoryDto") {
      return defaultSerializer(entity, { level: 0 });
    }

    return defaultSerializer(entity, options);
  },
};
